__turbopack_context__.v({
  "button": "AccordionItemTitle-module-scss-module__aM4KzG__button",
  "header": "AccordionItemTitle-module-scss-module__aM4KzG__header",
  "icon": "AccordionItemTitle-module-scss-module__aM4KzG__icon",
  "question": "AccordionItemTitle-module-scss-module__aM4KzG__question",
  "specificity": "AccordionItemTitle-module-scss-module__aM4KzG__specificity",
});
